import Navbar from "@/components/site/Navbar";
import Marquee from "react-fast-marquee";
import Hero from "@/components/site/Hero";
import SubHero from "@/components/site/SubHero";
import Problems from "@/components/site/Problems";
import Diagnostic from "@/components/site/Diagnostic";
import HowItWorks from "@/components/site/HowItWorks";
import Consulting from "@/components/site/Consulting";
import AboutFounder from "@/components/site/AboutFounder";
import Positioning from "@/components/site/Positioning";
import CalculatorTeaser from "@/components/site/CalculatorTeaser";
import FAQ from "@/components/site/FAQ";
import Credentials from "@/components/site/Credentials";
import Footer from "@/components/site/Footer";
import ScrollProgress from "@/components/site/ScrollProgress";
import MobileCTABar from "@/components/site/MobileCTABar";
import ScrollDepthTracker from "@/components/site/ScrollDepthTracker";
import SectionDivider from "@/components/site/SectionDivider";

const TICKER_WORDS = [
  "Atracción que no llega",
  "Selección que falla",
  "Onboarding que abandona",
  "Desempeño estancado",
  "Comunicación rota",
  "Retención imposible",
];

export default function Landing() {
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F7F9F8] text-[#06231D]">
      <ScrollDepthTracker />
      <ScrollProgress />
      <Navbar />
      <Hero />
      {/* Transición difusa y escalonada Hero → Calculadora (crossfade amplio) */}
      <div
        data-testid="hero-calculator-transition"
        className="relative h-40 sm:h-56 lg:h-[300px] flex items-center overflow-hidden border-y border-[#C9A84C]/45"
        style={{
          background:
            "linear-gradient(180deg, #06231D 0%, #053026 25%, #04221A 55%, #04180F 80%, #04120E 100%)",
        }}
      >
        <div aria-hidden className="absolute inset-x-0 top-3.5 bottom-3.5 border-y border-[#C9A84C]/20 pointer-events-none" />
        <div className="w-full marquee-track" data-testid="hero-calculator-ticker">
          <Marquee gradient={false} speed={58} pauseOnHover>
            {TICKER_WORDS.concat(TICKER_WORDS).map((w, i) => (
              <span
                key={i}
                className="mx-10 font-display text-xl md:text-2xl lg:text-3xl font-medium text-[#F7F9F8]/90 uppercase tracking-[0.08em] [word-spacing:0.32em] inline-flex items-center gap-10 whitespace-nowrap"
              >
                {w}
                <span className="w-1.5 h-1.5 rounded-full bg-[#2EC48A] inline-block" />
              </span>
            ))}
          </Marquee>
        </div>
      </div>
      <CalculatorTeaser />
      <SectionDivider />
      <Problems />
      <SectionDivider />
      <SubHero />
      <Positioning />
      <SectionDivider />
      <Diagnostic />
      <SectionDivider />
      <HowItWorks />
      <SectionDivider />
      <Consulting />
      <SectionDivider />
      <AboutFounder />
      <SectionDivider />
      <Credentials />
      <SectionDivider />
      <FAQ />
      <Footer />
      <MobileCTABar />
    </main>
  );
}
